import { ClickoutUrl } from '@/helpers/clickout-helper';
import { useExperiment } from '@/libraries/experiment';
import { getExperimentAffiliateTag } from '@/libraries/experiment/experiment-affiliation';

export function usePrimePlayPromoExp() {
	const { activeVariantWithControlGroup: variant, experimentInfo } = useExperiment('EXP_PRIME_PLAY_PROMO');

	function setPrimePlayPromoTags(
		url: ClickoutUrl,
		placement: 'ft' | 'ro' | 'play',
		shortName: string = '',
		technicalName: string = ''
	) {
		if (!variant.value) return url;

		const _placement = getPlacement(shortName, technicalName, placement);
		if (!_placement) return url;

		const affiliationShortId = experimentInfo.value.affiliationShortId as string;

		const providerShortName = _placement === 'ft' ? shortName : 'amp';

		const tag = getExperimentAffiliateTag({
			affiliationShortId,
			variant: variant.value,
			country: 'US',
			placement: _placement,
			providerShortName,
			technicalName,
		});
		return url.set('uct_ctag', tag);
	}

	return {
		setPrimePlayPromoTags,
	};
}

function getPlacement(shortName: string, technicalName: string, placement: 'ft' | 'ro' | 'play') {
	if (shortName === 'amp' || placement === 'ft') return placement;
	if (shortName === 'amz') return 'tvod';
	if (technicalName.startsWith('amazon') && technicalName !== 'amazonprime') return 'amzch';

	return null;
}
